//angular imports..
import { NgModule, ModuleWithProviders, ErrorHandler } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule, FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';
//component imports..
import { TopNavigation } from './component/topnavigation.component';
import { Footer } from './component/footercomponent';
import { Validator } from './component/validator.component';
import { ErrorPage } from './component/errorPage.component'
import { NotFoundComponent } from './component/notfound.component';

//services import..
import { DataShareService } from './services/datashare.service';
import { HttpServiceInetrceptor } from './services/httpinterceptor.interceptor';
import { AuthGuard } from './services/authguard.service';
import { AutherizationService } from './services/autherization.service';

import { GlobalErrorHandler } from './services/global.errorhandler';
import { ErroLoggingService } from './services/errorlogging.service';

import { MatchHeightDirective } from './directives/match-height.directive';

//Syncfusion
import { TextAreaModule } from '@syncfusion/ej2-angular-inputs'
import { ButtonModule } from '@syncfusion/ej2-angular-buttons'
import { CheckBoxModule } from '@syncfusion/ej2-angular-buttons'
import { DialogModule } from '@syncfusion/ej2-angular-popups';
import { RadioButtonModule } from '@syncfusion/ej2-angular-buttons'
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { DatePickerModule } from '@syncfusion/ej2-angular-calendars'
import { MultiSelectModule } from '@syncfusion/ej2-angular-dropdowns';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs'
import { UploaderModule } from '@syncfusion/ej2-angular-inputs'
import { GridModule } from '@syncfusion/ej2-angular-grids'

@NgModule({
    declarations: [
        TopNavigation,
        Validator,
        Footer,
        ErrorPage,
        MatchHeightDirective,
        NotFoundComponent
    ],
    imports: [
        RouterModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TextAreaModule,
        ButtonModule,
        CheckBoxModule,
        DialogModule,
        RadioButtonModule,
        DropDownListModule,
        DatePickerModule,
        MultiSelectModule,
        MaskedTextBoxModule,
        UploaderModule,
        GridModule,
    ],
    exports: [
        TopNavigation,
        Footer,
        ErrorPage,
        Validator,
        RouterModule,
        CommonModule,
        FormsModule,
        NotFoundComponent,
        ReactiveFormsModule,
        DatePipe,
        ButtonModule,
        TextAreaModule,
        CheckBoxModule,
        RadioButtonModule,
        DropDownListModule,
        DatePickerModule,
        MultiSelectModule,
        MaskedTextBoxModule,
        UploaderModule,
        GridModule,
        DialogModule,
        MatchHeightDirective,
    ]
})
export class SharedModule {

    static forRoot(): ModuleWithProviders<SharedModule> {
        return {
            ngModule: SharedModule,
            providers: [DataShareService, AuthGuard, AutherizationService, ErroLoggingService, {
                provide: HTTP_INTERCEPTORS,
                useClass: HttpServiceInetrceptor,
                multi: true
            },
                {
                    provide: ErrorHandler,
                    useClass: GlobalErrorHandler,
                }
            ]
        };
    }
}
